import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Stack, Box, Typography } from '@mui/material';

const CountSelector = ({ label, onChange, value }) => {
  const labels =
    label == 'bath'
      ? ['1', '2', '3', '4', '5+']
      : label == 'park'
      ? ['0', '1', '2', '3', '4', '5', '6+']
      : ['STUDIO', '1', '2', '3', '4', '5+'];
  const values =
    label == 'bath'
      ? [0, 1, 2, 3, 4]
      : 'park'
      ? [0, 1, 2, 3, 4, 5, 6]
      : [0, 1, 2, 3, 4, 5];

  const [selected, setSelected] = useState(new Object(value) || []);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleClick = (index) => {
    // Step 1: first click → start a new range
    if (selected.length === 0) {
      setSelected([index]);
      onChange([values[index]]);
      return;
    }

    // Step 2: second click → select the full range
    if (selected.length === 1) {
      const start = selected[0];
      const end = index;
      const min = Math.min(start, end);
      const max = Math.max(start, end);
      const range = Array.from({ length: max - min + 1 }, (_, i) => min + i);
      setSelected(range);
      if (label == 'bath') {
        onChange(range.map((i) => values[i]));
        return;
      } else {
        onChange(range.map((i) => values[i]));
        return;
      }
    }

    // Step 3: third click → reset and start new range from this index
    setSelected([index]);
    onChange([values[index]]);
  };

  const handleReset = () => {
    setSelected([]);
    onChange([]);
  };

  const handleChange = (newSelected) => {
    if (newSelected.length === 0) {
      onChange([]);
    } else {
      const sorted = newSelected.map((i) => values[i]).sort((a, b) => a - b);
      const [start, end] =
        sorted.length === 1 ? [sorted[0], sorted[0]] : [sorted[0], sorted[1]];
      const range = Array.from(
        { length: end - start + 1 },
        (_, i) => start + i
      );
      onChange(range);
    }
  };

  return (
    <Stack spacing={1} width={'100%'} paddingX={'10px'}>
      <Box display="flex" justifyContent="right" alignItems="center">
        <Button variant="text" size="small" onClick={handleReset}>
          Reset
        </Button>
      </Box>

      <ButtonGroup variant="outlined" fullWidth>
        {labels.map((text, index) => (
          <Button
            key={text}
            onClick={() => handleClick(index)}
            variant={selected.includes(index) ? 'contained' : 'outlined'}
            sx={{
              fontSize: '12px',
              backgroundColor: selected.includes(index)
                ? 'rgba(25, 118, 210, 0.2)'
                : undefined,
              color: selected.includes(index) ? 'primary.main' : undefined,
              // borderColor: selected.includes(index) ? 'primary.main' : undefined,
              '&:hover': {
                backgroundColor: selected.includes(index)
                  ? 'rgba(25, 118, 210, 0.4)' // slightly darker when hovered
                  : 'primary.main',
                color: '#fff',
              },
            }}
          >
            {text}
          </Button>
        ))}
      </ButtonGroup>
    </Stack>
  );
};

export default CountSelector;
